import React from 'react';
import SoftwareSelectionCard from '../../Components/SoftwareSelectionCard';
import HealthHeader from '../../Components/HealthHeader';
import './styles.css';

// Ícones temporários - você pode substituir por seus próprios ícones
const EffectsIcon = () => (
  <div style={{ width: 64, height: 64, background: '#ddd', borderRadius: '50%' }} />
);

const PainIcon = () => (
  <div style={{ width: 64, height: 64, background: '#ddd', borderRadius: '50%' }} />
);

const SoftwareSelection = () => {
  return (
    <div className="software-selection">
      <HealthHeader title="Seleção de Software" />
      <div className="software-selection__content">
        <h2 className="software-selection__subtitle"></h2>
        <div className="software-selection__cards">
          <SoftwareSelectionCard
            title="Efeitos Adversos"
            description="Gerencie e monitore efeitos adversos"
            icon={<EffectsIcon />}
            route="/efeitos-adversos/home"
            isSelected={true}
          />
          <SoftwareSelectionCard
            title="Dor"
            description="Sistema de gerenciamento de dor"
            icon={<PainIcon />}
            route="/dor/home"
            isSelected={false}
          />
        </div>
      </div>
    </div>
  );
};

export default SoftwareSelection; 